import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getCertificationProfessionalStart,
  getCertificationProfessionalSuccess,
  getCertificationProfessionalFailed,
} from "../redux/getCertificationProfessional";

import { getCertificationProfessionalApi } from "core/http/service/personnelInformation";

function* getCertificationProfessionalWork() {
  try {
    const res = yield call(getCertificationProfessionalApi);

    yield put({
      type: getCertificationProfessionalSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getCertificationProfessionalFailed.type,
    });
  }
}

function* watchGetCertificationInformation() {
  yield takeLatest(
    getCertificationProfessionalStart.type,
    getCertificationProfessionalWork
  );
}

export default function* getCertificationProfessionalSaga() {
  yield all([watchGetCertificationInformation()]);
}
